export const PHONE_COUNTRY_CODES: string[] = [
  '+1',
  '+20',
  '+27',
  '+30',
  '+31',
  '+32',
  '+33',
  '+34',
  '+36',
  '+39',
  '+40',
  '+41',
  '+43',
  '+44',
  '+45',
  '+46',
  '+47',
  '+48',
  '+49',
  '+51',
  '+52',
  '+53',
  '+54',
  '+55',
  '+56',
  '+57',
  '+58',
  '+60',
  '+61',
  '+62',
  '+63',
  '+64',
  '+65',
  '+66',
  '+81',
  '+82',
  '+84',
  '+86',
  '+90',
  '+91',
  '+92',
  '+93',
  '+94',
  '+95',
  '+98',
  '+212',
  '+213',
  '+216',
  '+218',
  '+220',
  '+221',
  '+225',
  '+234',
  '+249',
  '+251',
  '+254',
  '+255',
  '+256',
  '+258',
  '+260',
  '+263',
  '+264',
  '+265',
  '+266',
  '+267',
  '+268',
  '+271',
  '+297',
  '+298',
  '+299',
  '+350',
  '+351',
  '+352',
  '+353',
  '+354',
  '+355',
  '+356',
  '+357',
  '+358',
  '+359',
  '+370',
  '+371',
  '+372',
  '+373',
  '+374',
  '+375',
  '+376',
  '+377',
  '+378',
  '+380',
  '+381',
  '+382',
  '+385',
  '+386',
  '+387',
  '+389',
  '+390',
  '+420',
  '+421',
  '+423',
  '+500',
  '+501',
  '+502',
  '+503',
  '+504',
  '+505',
  '+506',
  '+507',
  '+508',
  '+509',
  '+591',
  '+592',
  '+593',
  '+594',
  '+595',
  '+598',
  '+599',
  '+591',
  '+595',
  '+597',
  '+598',
  '+599',
  '+670',
  '+673',
  '+674',
  '+675',
  '+676',
  '+678',
  '+679',
  '+680',
  '+681',
  '+682',
  '+683',
  '+685',
  '+686',
  '+687',
  '+688',
  '+689',
  '+690',
  '+691',
  '+692',
  '+850',
  '+852',
  '+853',
  '+855',
  '+856',
  '+870',
  '+872',
  '+873',
  '+874',
  '+880',
  '+881',
  '+882',
  '+883',
  '+886',
  '+90',
  '+91',
  '+94',
  '+960',
  '+961',
  '+962',
  '+963',
  '+964',
  '+965',
  '+966',
  '+967',
  '+971',
  '+972',
  '+973',
  '+974',
  '+975',
  '+976',
  '+977',
  '+98',
  '+992',
  '+993',
  '+994',
  '+995',
  '+996',
  '+998',
] as string[];

export type PhoneCountryCode = string;

export interface PhoneValidationResult {
  phone: string;
  countryCode: string;
}

function normalizeCountryCode(countryCode: string): string {
  const normalized = countryCode.trim().startsWith('+') ? countryCode.trim() : `+${countryCode.trim()}`;
  if (!/^\+\d{1,4}$/.test(normalized)) {
    throw new Error('Country code must be in E.164 format, for example: +506');
  }
  return normalized;
}

function digitsOnly(phone: string): string {
  return phone.replace(/[^\d]/g, '');
}

function stripCountryCodeDigits(phoneDigits: string, countryCode: string): string {
  const codeDigits = countryCode.replace('+', '');
  return phoneDigits.startsWith(codeDigits) ? phoneDigits.slice(codeDigits.length) : phoneDigits;
}

export function normalizeRegistrationPhone(phone: string, countryCode: string): string {
  const normalizedCode = normalizeCountryCode(countryCode);
  const phoneDigits = digitsOnly(phone);

  if (!phoneDigits) {
    throw new Error('Phone number is required.');
  }

  const localDigits = stripCountryCodeDigits(phoneDigits, normalizedCode);
  if (localDigits.length < 4 || localDigits.length > 15) {
    throw new Error('Phone number local part must be between 4 and 15 digits.');
  }

  return `${normalizedCode}${localDigits}`;
}

export function getValidatedPhoneInput(phone: string, countryCode: string): PhoneValidationResult {
  const normalizedCode = normalizeCountryCode(countryCode);
  return {
    phone: normalizeRegistrationPhone(phone, normalizedCode),
    countryCode: normalizedCode,
  };
}
